<template>
    <metainfo>
      <template v-slot:title="{ content }">{{ content }}</template>
    </metainfo>
  <router-view/>
</template>
